import { Chip } from '@mui/material';
import React from 'react';

interface BkInformationChipProps {
  label: string;
  icon?: React.ReactElement;
  backgroundColor?: string;
}

const BkInformationChip: React.FC<BkInformationChipProps> = ({
  label,
  icon,
  backgroundColor = '#E8FCF1'
}) => {
  return (
    <Chip
      icon={icon}
      sx={{
        background: backgroundColor,
        fontWeight: '500',
        borderRadius: '0.75rem',
        color: '#0F3010',
        '& svg': {
          color: '#000000 !important',
        },
      }}
      label={label}
    />
  );
};

export default BkInformationChip;
